// removed by extract-text-webpack-plugin
module.exports = {"container":"TextArea__container___1glW2Yk","textArea":"TextArea__textArea___2LjT3NN"};